// extracted by mini-css-extract-plugin
export default {"text-area":"TextArea_text-area__uB3ll","secondary":"TextArea_secondary__25YgU"};